const baseGradient =
    "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.42) 48.44%, rgba(0, 0, 0, 0.42) 100%)";

const darkGradient =
    "linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0.7637648809523809) 64%, rgba(0,0,0,0.5144651610644257) 79%, rgba(0,0,0,0) 97%, rgba(111,111,111,0) 100%);";

export const READ_MORE_EXPANDED_CLASSNAME = "storytile-readmore-expanded";

export const styles = {
    description: {
        fontSize: ["mobileBodyB1", "desktopH4"],
        overflow: "initial",
        color: "gray.800",
        pt: 4,
    },
    descriptionCarousel: {
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0.2px",
        fontWeight: "normal",
        color: "gray.500",
        pt: 0,
        minH: ["72px", "84px"],
        overflow: "hidden",
    },
    description3col: {
        fontSize: "16px",
        lineHeight: "24px",
        color: "gray.500",
        pt: 0,
    },
    label3col: {
        fontSize: "16px",
        lineHeight: "16px",
        letterSpacing: "0.4px",
    },
    headline3col: {
        fontSize: ["mobileH2", "desktopH2"],
        lineHeight: ["32px", "48px"],
        letterSpacing: "0.2px",
    },
    headlineCarousel: {
        fontSize: ["mobileH2", "desktopH2"],
        lineHeight: ["32px", "48px"],
        letterSpacing: "0.2px",
    },
    readMore: {
        overflow: "hidden",
        [`&:has(.${READ_MORE_EXPANDED_CLASSNAME})`]: {
            overflow: "initial",
        },
    },
    headlineDesktop: {
        w: "full",
        fontSize: ["mobileHeading2", "desktopHeading2"],
        fontWeight: "bold",
        textAlign: "right" as const,
    },
    headlineMobile: {
        fontSize: "mobileHeading1",
        fontWeight: "bold",
        textAlign: "right" as const,
    },
    headline: {
        fontSize: ["mobileH3", "desktopH3"],
        fontWeight: "bold",
    },
    squareImage: {
        position: "relative" as const,
        w: "full",
        minW: 0,
        flexShrink: 0,
        overflow: "hidden",
        display: "block",
        _before: {
            content: '""',
            display: "block",
            paddingTop: "100%",
        },
    },
    squareImageHiddenOnMobile: {
        position: "relative" as const,
        w: "full",
        minW: 0,
        flexShrink: 0,
        overflow: "hidden",
        display: { base: "none", xl: "block" },
        _before: {
            content: '""',
            display: "block",
            paddingTop: "100%",
        },
    },
    imageFill: {
        position: "absolute" as const,
        inset: 0,
    },
    imagePlaceholder: {
        bg: "white",
        w: "full",
        h: "full",
    },
    label: {
        fontWeight: "bold",
        textTransform: "uppercase" as const,
        flexShrink: 0,
    },
    labelSpacer: {
        flexShrink: 0,
    },
    labelSpacerCard: {
        minH: "16px",
    },
    labelSpacerDefault: {
        minH: ["14px", "15px"],
    },
    labelDefault: {
        fontSize: ["mobileH5", "desktopH5"],
    },
    headlineDefault: {
        fontSize: ["mobileH3", "desktopH3"],
    },
    textContentGrid: {
        py: "18px",
        pr: "12px",
        flex: 1,
        display: "flex",
        flexDirection: "column" as const,
        minH: 0,
    },
    textContentCarouselMobile: {
        pl: "12px",
        pr: "12px",
        py: "18px",
        flex: 1,
        display: "flex",
        flexDirection: "column" as const,
        minH: 0,
    },
    textContentCarouselDesktop: {
        pl: "12px",
        pr: "12px",
        flex: 1,
        display: "flex",
        flexDirection: "column" as const,
        minH: 0,
    },
    textContentDefault: {
        py: [3, 4],
        flex: 1,
        display: "flex",
        flexDirection: "column" as const,
        minH: 0,
    },
    textContentInner: {
        flexDirection: "column" as const,
        gap: "8px",
        flex: 1,
    },
    textContentInnerDefault: {
        flexDirection: "column" as const,
        gap: 1,
        flex: 1,
    },
    textGroup: {
        flexDirection: "column" as const,
        gap: "8px",
    },
    linksGrid: {
        pt: "24px",
        mt: "auto",
        flexShrink: 0,
    },
    linksCarousel: {
        pt: "16px",
        mt: "auto",
        flexShrink: 0,
    },
    linksDefault: {
        pt: 4,
        mt: "auto",
        flexShrink: 0,
    },
    rootCard: {
        flexDirection: "column" as const,
        w: "full",
        minW: 0,
        h: "100%",
        flex: 1,
    },
    rootCarouselCardMobile: {
        flexDirection: "column" as const,
        w: "full",
        minW: 0,
        h: "100%",
        bg: "white",
    },
    rootCarouselCardDesktop: {
        flexDirection: "column" as const,
        w: "full",
        minW: 0,
        h: "100%",
        bg: "white",
        px: "4px",
        pt: "4px",
        pb: "8px",
        gap: "20px",
    },
    rootDefault: {
        flexDirection: "column" as const,
        w: "full",
        minW: 0,
    },
    coloredBar: {
        h: "20px",
        w: "full",
        flexShrink: 0,
    },
};

export const gradientBox = (whiteBackground: boolean) => ({
    padding: whiteBackground ? "0" : "6",
    height: "100%",
    justifyContent: "end",
    backgroundImage: whiteBackground ? "" : baseGradient,
    position: { base: whiteBackground ? "relative" : "absolute", xl: "absolute" },
    left: "0",
    bottom: "0",
    right: "0",
    backgroundSize: { base: "100% 50%", sm: "100% 30%" },
    backgroundPosition: "bottom",
    backgroundRepeat: "no-repeat",
    [`&:has(.${READ_MORE_EXPANDED_CLASSNAME})`]: {
        backgroundImage: darkGradient,
    },
});

export const textWrapper = (whiteBackground: boolean) => ({
    position: { base: whiteBackground ? "relative" : "absolute", xl: "absolute" },
    bottom: "0",
    left: "0",
    gap: "0.2",
    p: ["3", "4", "6"],
    width: "full",
    flexDirection: "column",
    maxHeight: "100%",
    overflowY: "scroll",
    "::-webkit-scrollbar": { display: "none" },
});
